import React from "react";
import { CheckAuth } from "../../Util";
import Home from "./Home";

class UserLanding extends Home {
  render() {
    let user = CheckAuth();
    return (
      <div>
        <div style={{ backgroundColor: "#22A5DB", height: "100px" }}>
          <div className="container" style={{ paddingTop: 30 }}>
            <span style={{ color: "white", fontSize: 32 }}>
              Halo, {user.nama}
            </span>
          </div>
        </div>
        <div className="pb-l pt-m" style={{ backgroundColor: "white" }}>
          {this.getSection()}
        </div>
      </div>
    );
  }
}

export default UserLanding;



// WEBPACK FOOTER //
// ./src/components/Public/Home/UserLanding.js